import { observable } from "mobx";
import { Type } from "class-transformer";
import BankAccountStatus from "./bankAccountStatus";
import CurrencyCode from "./currencyCode";
import DomesticBankAccountResponse from "./domesticBankAccountResponse";
import SourceType from "./sourceType";
import Enum from "./enum";
import Optionable from "utils/optionable";
import { formatBankAccount } from "@edaz/utils/bankAccount";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
@Optionable((bankAccountEnum: BankAccountResponse) => ({
  id: bankAccountEnum.id,
  label: formatBankAccount(bankAccountEnum.bankAccount),
}))
export default class BankAccountResponse extends Enum {
  /**
   * Bank account unique ID.
   */
  id!: string;

  @observable
  status!: BankAccountStatus;

  @observable
  sourceType!: SourceType;

  @observable
  @Type(() => DomesticBankAccountResponse)
  bankAccount!: DomesticBankAccountResponse;

  /**
   * Bank account number in IBAN format.
   */
  @observable
  iban!: string;

  /**
   * Optional description.
   */
  @observable
  description!: string;

  @observable
  currencyCode!: CurrencyCode;
}
